'use es6';

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import H2 from 'UIComponents/elements/headings/H2';
import ClickableHeader from '../../Header/ClickableHeader';
import Oas from '../../../lib/api-explorer/models/Oas';
import { setLanguage } from '../actions';
import { getDefaultLanguage } from '../selectors/LanguageSelectors';
import { getFilteredOasDocs, getSectionHeadings } from '../selectors/DocSelectors';
import { stringToId } from '../../../utils/urls';
import Doc from './Doc';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApiExplorerH2 = styled(ClickableHeader).withConfig({
  displayName: "ApiExplorer__ApiExplorerH2",
  componentId: "sc-1wged9h-0"
})(["padding:20px 0 0 0;"]);
class ApiExplorer extends Component {
  constructor(props) {
    super(props);
    this.setLanguage = language => {
      this.setState({
        language
      });
      setLanguage(language);
    };
    this.changeSelected = selected => {
      this.setState({
        selectedApp: {
          selected,
          changeSelected: this.changeSelected
        }
      });
    };
    this.maybeRenderSectionHeading = (slug, renderedTagNames, sectionHeadings) => {
      const sectionHeading = sectionHeadings.find(heading => heading.name === slug);
      if (sectionHeading && renderedTagNames.indexOf(slug) === -1) {
        renderedTagNames.push(slug);
        return /*#__PURE__*/_jsx(ApiExplorerH2, {
          Component: H2,
          id: stringToId(slug),
          children: slug
        });
      } else {
        return null;
      }
    };
    this.state = {
      language: this.props.language,
      selectedApp: {
        selected: '',
        changeSelected: this.changeSelected
      }
    };
  }
  getOas(doc) {
    // Get the apiSetting id from the following places:
    // - category.apiSetting if set and populated
    // - api.apiSetting if that's a string
    // - api.apiSetting._id if that's set
    // This will return undefined if apiSetting is not set
    const apiSetting = doc.category.apiSetting || typeof doc.api.apiSetting === 'string' && doc.api.apiSetting || typeof doc.api.apiSetting === 'object' && doc.api.apiSetting && doc.api.apiSetting._id;
    return new Oas(this.props.oasFiles[apiSetting]);
  }
  render() {
    const {
      oasDocs,
      sectionHeadings
    } = this.props;
    const renderedTagNames = [];
    return /*#__PURE__*/_jsx("div", {
      className: `is-lang-${this.state.language}`,
      "data-test-id": "doc",
      children: oasDocs.map(doc => {
        const DocComponent = Doc;
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [sectionHeadings && doc.slug && this.maybeRenderSectionHeading(doc.slug, renderedTagNames, sectionHeadings), /*#__PURE__*/_jsx(DocComponent, {
            doc: doc,
            oasDocs: oasDocs,
            setLanguage: this.setLanguage,
            flags: this.props.flags,
            language: this.state.language,
            headerId: this.props.headerId,
            usageTracker: this.props.usageTracker
          })]
        }, doc._id);
      })
    });
  }
}
ApiExplorer.defaultProps = {
  flags: {
    correctnewlines: false
  }
};
ApiExplorer.propTypes = {
  filteredOasDocs: PropTypes.arrayOf(PropTypes.object).isRequired,
  oasFiles: PropTypes.shape({}).isRequired,
  sectionHeadings: PropTypes.arrayOf(PropTypes.object).isRequired,
  flags: PropTypes.shape({
    correctnewlines: PropTypes.bool
  }).isRequired,
  language: PropTypes.string.isRequired,
  oasDocs: PropTypes.array.isRequired,
  headerId: PropTypes.string,
  usageTracker: PropTypes.object
};
const mapStateToProps = state => {
  return {
    filteredOasDocs: getFilteredOasDocs(state),
    sectionHeadings: getSectionHeadings(state),
    language: getDefaultLanguage(state)
  };
};
export default connect(mapStateToProps)(ApiExplorer);